<div class="modal-header">
  <h2 class="text-b1-m-900 text-lg-h4-s">Выбрать город</h2>
</div>

<div class="modal-body">
  <p class="info-delivery text-b3-m-700">в этом населённом пункте отсутствует магазин.</p>

  <div class="info-phone text-b3-m-300">
    Возможность доставки можно уточнить по телефону
    <sd-phone class="phone text-b3-m-300 link-black link-hover-underlined link-hover-orange"></sd-phone>
  </div>
</div>

<div class="modal-footer">
  <button sdButton [theme]="buttonThemes.Primary" [fullWidth]="true" (click)="changeCities($event)">изменить</button>
</div>
